import React from 'react';
import { connect } from 'dva';
import PropTypes from 'prop-types';
import { SidebarActions, ActionButton } from '../../SidebarActions';
import actions from './actions';
import ArrowUpRight from '../../../../assets/svg/Feather/ArrowUpRight';
import CornerRightUp from '../../../../assets/svg/Feather/CornerRightUp';
import Pencil from '../../../../assets/svg/Feather/Pencil';
import Pushpin from '../../../../assets/svg/Remix/Pushpin';
import styles from './CollectionDetailActions.module.scss';
import Trash2 from '../../../../assets/svg/Feather/Trash2';

export const CollectionDetailActions = (props) => {
  const togglePinCollection = () => {
    if (props.collectionIsPinned) {
      props.setPinnedCollection(null);
    } else {
      props.setPinnedCollection(props.selectedCollection.uuid);
    }
  };

  const showDeleteModal = () => {
    props.showDeleteModal(props.selectedCollection.uuid);
  };

  const showExportModal = () => {
    props.showExportModal(props.selectedCollection);
  };

  const editCollection = () => {
    if (!props.isEditingCollection) {
      props.setInitialCollectionName(props.selectedCollection.title);
    }
    props.toggleEditCollection();
  };

  const leaveCollection = () => {
    props.showLeftShare(props.selectedCollection);
  };

  return (
    <div className={styles.container}>
      <SidebarActions>
        {props.selectedCollection && props.selectedCollection.isOwner ? (
          <>
            <ActionButton icon={Pencil} active={props.isEditingCollection} onClick={editCollection}>
              Edit
            </ActionButton>
            <ActionButton icon={Pushpin} active={props.collectionIsPinned} onClick={togglePinCollection}>
              Active
            </ActionButton>
            <ActionButton icon={CornerRightUp} onClick={showExportModal}>
              Export
            </ActionButton>
            <ActionButton icon={Trash2} onClick={showDeleteModal}>
              Delete
            </ActionButton>
          </>
        ) : (
          <>
            <ActionButton icon={ArrowUpRight} onClick={leaveCollection}>
              Leave
            </ActionButton>
          </>
        )}
      </SidebarActions>
    </div>
  );
};

CollectionDetailActions.propTypes = {
  collectionIsPinned: PropTypes.bool,
  isEditingCollection: PropTypes.bool,
  pinnedCollectionId: PropTypes.string,
  selectedCollection: PropTypes.object,
  //actions
  setInitialCollectionName: PropTypes.func,
  setPinnedCollection: PropTypes.func,
  showDeleteModal: PropTypes.func,
  showErrorToast: PropTypes.func,
  showExportModal: PropTypes.func,
  showLeftShare: PropTypes.func,
  toggleEditCollection: PropTypes.func,
};

export default connect(model => {
  const { isEditingCollection, preferences, selectedCollection } = model.collections
  return {
    collectionIsPinned: preferences.pinned === selectedCollection.uuid,
    isEditingCollection,
    pinnedCollectionId: preferences.pinned,
    selectedCollection,
  }
}, actions)(CollectionDetailActions);
